<template>
  <el-tag :type="meta.type" :size="size" :effect="effect" class="gas-status-tag">
    {{ meta.label }}
  </el-tag>
</template>

<script>
import { resolveStatus } from '@/utils/statusTag'

export default {
  name: 'GasStatusTag',
  props: {
    kind: { type: String, required: true },
    value: { type: [String, Number, Boolean], default: '' },
    size: { type: String, default: 'small' },
    effect: { type: String, default: 'light' }
  },
  computed: {
    meta() {
      return resolveStatus(this.kind, this.value)
    }
  }
}
</script>

<style scoped>
.gas-status-tag {
  border: none;
  font-weight: 500;
}
</style>
